import React, { useState } from 'react';

export const Giving = () => {
  const [showDetails, setShowZoom] = useState(false);

  return (
    <section id="giving" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-primary font-bold tracking-[0.3em] uppercase text-xs mb-6">Generosity</p>
              <h2 className="text-4xl sm:text-6xl font-bold mb-8 leading-tight">
                Support Our <br /><span className="text-primary italic font-light">Mission</span>
              </h2>
              <p className="text-lg text-secondary/60 mb-8">
                Your generosity enables us to reach more people with the gospel and serve our community. Every gift, no matter the size, makes a difference.
              </p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-secondary/70">Secure and direct bank transfers</p>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-secondary/70">Transparent financial stewardship</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-primary/10 rounded-[3rem] blur-2xl"></div>
              <div className="relative bg-secondary p-10 sm:p-16 rounded-[3rem] text-white shadow-2xl">
                <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-8 backdrop-blur-sm">
                  <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold mb-6">Bank Transfer</h3>
                <p className="text-white/60 mb-10">Click the button below to view our secure bank details for your donation.</p>
                
                {!showDetails ? (
                  <button 
                    onClick={() => setShowZoom(true)}
                    className="btn-primary w-full"
                  >
                    View Bank Details
                  </button>
                ) : (
                  <div className="space-y-6 animate-fade-in">
                    <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                      <div className="space-y-4">
                        <div>
                          <p className="text-[10px] uppercase tracking-widest text-primary font-bold mb-1">Account Name</p>
                          <p className="text-lg font-bold">EWG GRACE TEMPLE</p>
                        </div>
                        <div>
                          <p className="text-[10px] uppercase tracking-widest text-primary font-bold mb-1">Sort Code</p>
                          <p className="text-lg font-bold tracking-widest">80-22-60</p>
                        </div>
                        <div>
                          <p className="text-[10px] uppercase tracking-widest text-primary font-bold mb-1">Account Number</p>
                          <p className="text-lg font-bold tracking-widest">19344460</p>
                        </div>
                      </div>
                    </div>
                    <p className="text-xs text-center text-white/40 italic">Thank you for your faithful support!</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
